import { useBackgroundProductInfoFetcher } from 'products/components/backgroundCategorieFetcher'

const BackgroundFetcher = () => {
    useBackgroundProductInfoFetcher()

    return null
}

export default BackgroundFetcher
